import type { DockSectionDefinition } from "./sectionTypes";
import { ActivityDockOpenQcSection } from "./sections/ActivityDockOpenQcSection";
import { MFG_BUILDER_ASSISTANT_ROLES } from "@/lib/roles/turboManufacturingRoles";

export const OPEN_QC_DOCK_ENTRIES: readonly DockSectionDefinition[] = [
  {
    id: "open-qc",
    roleGate: { roles: MFG_BUILDER_ASSISTANT_ROLES },
    render: (ctx) => (
      <ActivityDockOpenQcSection
        items={ctx.openQcItems ?? null}
        onOpenBuilderAssistant={ctx.onOpenMfgBuilderAssistant}
      />
    ),
    bucketRelevance: ["production"],
    modeRelevance: ["mfgBuilderAssistant"],
    hasSignal: (ctx) => (ctx.openQcCount ?? 0) > 0,
  },
];
